import apiClient from "@/shared/api/apiClient2";

function failure(label, e) {
  console.error(`[transaction/api] ${label}`, e);
  return {
    success: false,
    error: e?.response?.data || e?.message || String(e),
  };
}

export const getAvailableActions = async ({
  transactionId,
  applicationUuid,
} = {}) => {
  const hasTx =
    transactionId !== undefined &&
    transactionId !== null &&
    transactionId !== "";
  const hasApp =
    applicationUuid !== undefined &&
    applicationUuid !== null &&
    applicationUuid !== "";

  if (hasTx === hasApp) {
    return failure(
      "getAvailableActions",
      new Error(
        "Передайте ровно один из параметров: transactionId или applicationUuid"
      )
    );
  }

  const params = hasTx
    ? { transaction_id: transactionId }
    : { application_uuid: applicationUuid };

  try {
    const { data } = await apiClient.get("/available-actions", { params });
    return data;
  } catch (e) {
    return failure("getAvailableActions", e);
  }
};
